import type { Brand } from '../hooks/useBrand';

interface Props {
  brand: Brand | null;
}

export function BrandHeader({ brand }: Props) {
  return (
    <header className="w-full border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-3xl items-center gap-3 px-4 py-4 sm:px-6">
        {brand?.logoUrl ? (
          <img
            src={brand.logoUrl}
            alt={brand.brandName ? `${brand.brandName} logo` : 'Brand logo'}
            className="h-8 w-auto sm:h-10"
          />
        ) : (
          <div className="h-8 w-8 rounded bg-slate-200 sm:h-10 sm:w-10" aria-hidden />
        )}
        <h1 className="text-base font-semibold text-slate-900 sm:text-lg">
          {brand?.brandName ?? ' '}
        </h1>
      </div>
    </header>
  );
}
